import moment from 'moment'

export const dateFormat = 'YYYY-MM-DD'
export const displayDateFormat = 'yyyy-MM-dd'
export const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const displayDateTimeFormat = 'yyyy-MM-dd HH:mm:ss'
export const pdfDateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

export function strDateToDate(strDate: string): Date {
  if (strDate) {
    return moment(strDate, dateFormat).toDate()
  }
}

export function strDateTimeToDate(strDateTime: string): Date {
  if (strDateTime) {
    return moment(strDateTime, dateTimeFormat).toDate()
  }
}

export function strDateTimeToDisplayDate(strDateTime: string): string {
  if (strDateTime) {
    return moment(strDateTime).format(pdfDateTimeFormat)
  }
}
